import moment from "moment";

function clampToZoomRoot(pos, w, h, pad = 8) {
  const zr = document.getElementById("zoom-root")?.getBoundingClientRect();
  if (!zr || !pos) return { left: pos?.x || 0, top: pos?.y || 0 };
  const minL = zr.left + pad;
  const minT = zr.top + pad;
  const maxL = zr.right - pad - (w || 0);
  const maxT = zr.bottom - pad - (h || 0);
  return {
    left: Math.max(minL, Math.min(pos.x, maxL)),
    top: Math.max(minT, Math.min(pos.y, maxT)),
  };
}

export function CommentTooltip({ comment, position, isVisible }) {
  if (!isVisible) return null;
  const size = { w: 230, h: 110 };
  const { left, top } = clampToZoomRoot(position, size.w, size.h);

  return (
    <div
      className="image_analysis_container absolute z-50 pointer-events-none"
      // style={{
      //   left: Math.min(position.x + 400, window.innerWidth - 10),
      //   top: Math.max(position.y - 5, 10),
      // }}
      style={{
        position: "fixed",
        left,
        top,
        width: size.w,
        pointerEvents: "none",
      }}
    >
      <div
        className="bg-white rounded-[16px] rounded-bl-none border border-[#EDF0F3] px-3 py-2 shadow-lg max-w-xs"
        style={{
          boxShadow:
            "0 4px 6px 0 rgba(14, 18, 27, 0.06), 0 2px 4px 0 rgba(14, 18, 27, 0.03)",
        }}
      >
        <div className="flex flex-col mb-2">
          <span className="text-[16px] font-medium text-[#000000]">
            {comment.author}
          </span>
          <span className="text-[11px] text-[#535353]">
            {moment(comment.timestamp).fromNow()}
          </span>
        </div>
        <p className="text-sm text-[#535353]">{comment.text}</p>

        {/* Arrow pointing to comment pin */}
        <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2">
          <div className="w-0 h-0 border-t-4 border-b-4 border-r-4 border-transparent border-r-gray-900"></div>
        </div>
      </div>
    </div>
  );
}
